import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

/* eslint-disable no-undefined,react/display-name,@typescript-eslint/no-explicit-any */
import React from "react";
import { usePagination as paginationPlugin, useRowSelect as rowSelectPlugin, useSortBy as sortPlugin } from "react-table";
import { TableCheckbox, TableRadioBtn } from "../components";
export var applyPaginationPlugin = function applyPaginationPlugin(_ref) {
  var config = _ref.config,
      extensions = _ref.extensions,
      pagination = _ref.pagination;
  var itemsPerPage = pagination.itemsPerPage,
      currentPage = pagination.currentPage,
      autoResetPage = pagination.autoResetPage;
  config.autoResetPage = autoResetPage;

  if (itemsPerPage) {
    config.initialState.pageSize = itemsPerPage;
  }

  if (currentPage) {
    config.initialState.pageIndex = currentPage - 1;
  }

  extensions.push(paginationPlugin);
};
export var applySortingPlugin = function applySortingPlugin(_ref2) {
  var config = _ref2.config,
      extensions = _ref2.extensions,
      sorting = _ref2.sorting;
  var manualSortBy = sorting.manualSortBy,
      disableMultiSort = sorting.disableMultiSort,
      autoResetSortBy = sorting.autoResetSortBy,
      disableSortRemove = sorting.disableSortRemove,
      defaultColumnsConfig = sorting.defaultColumnsConfig;
  config.manualSortBy = manualSortBy;
  config.disableMultiSort = disableMultiSort;
  config.autoResetSortBy = autoResetSortBy;
  config.disableSortRemove = disableSortRemove;

  if (defaultColumnsConfig) {
    config.initialState.sortBy = defaultColumnsConfig.map(function (cfg) {
      return {
        id: cfg.accessor,
        desc: cfg.desc
      };
    });
  }

  extensions.push(sortPlugin);
};
export var applySelectionPlugin = function applySelectionPlugin(_ref3) {
  var config = _ref3.config,
      extensions = _ref3.extensions,
      selection = _ref3.selection;
  var isMulti = selection.isMulti,
      manualRowSelectedKey = selection.manualRowSelectedKey,
      autoResetSelectedRows = selection.autoResetSelectedRows;
  config.manualRowSelectedKey = manualRowSelectedKey;
  config.autoResetSelectedRows = autoResetSelectedRows;

  if (!isMulti) {
    config.stateReducer = function (newState, action) {
      if (action.type === "toggleRowSelected") {
        newState.selectedRowIds = _defineProperty({}, action.id, true);
      }

      return newState;
    };
  }

  extensions.push(rowSelectPlugin);
};
export var addMultiRowSelection = function addMultiRowSelection(visibleColumns, getClassName) {
  visibleColumns.push(function (columns) {
    var firstColumn = columns.slice(0, 1)[0];
    var restColumns = columns.slice(1);

    firstColumn.renderSelectionCell = function (Cell) {
      return function (_ref4) {
        var row = _ref4.row,
            column = _ref4.column;
        return /*#__PURE__*/React.createElement("div", {
          className: getClassName({
            descendantName: "tableCheckbox"
          })
        }, /*#__PURE__*/React.createElement(TableCheckbox, _extends({}, row.getToggleRowSelectedProps(), {
          id: row.id,
          ariaLabel: column.selectionAriaLabel
        })), Cell);
      };
    };

    return [firstColumn].concat(_toConsumableArray(restColumns));
  });
};
export var addSingleRowSelection = function addSingleRowSelection(visibleColumns, getClassName, tableRef) {
  visibleColumns.push(function (columns) {
    var firstColumn = columns.slice(0, 1)[0];
    var restColumns = columns.slice(1);

    firstColumn.renderSelectionCell = function (Cell) {
      return function (_ref5) {
        var row = _ref5.row,
            column = _ref5.column;
        return /*#__PURE__*/React.createElement("div", {
          className: getClassName({
            descendantName: "tableRadioBtn"
          })
        }, /*#__PURE__*/React.createElement(TableRadioBtn, _extends({}, row.getToggleRowSelectedProps(), {
          id: row.id,
          ariaLabel: column.selectionAriaLabel,
          tableRef: tableRef
        })), Cell);
      };
    };

    return [firstColumn].concat(_toConsumableArray(restColumns));
  });
};